import axios from 'axios'
import store from '../store'

// Endpoints that are themselves part of signing in. A 401 from these means
// "those credentials were wrong", not "your session died", so we must not
// react to them by popping the login modal.
const AUTH_ENDPOINTS = [
  '/bruker/login',
  '/bruker/verify',
  '/bruker/forgot-password',
  '/bruker/reset-password'
]

const isAuthEndpoint = (url) => {
  if (!url) {
    return false
  }

  return AUTH_ENDPOINTS.some(endpoint => url.indexOf(endpoint) !== -1)
}

export default () => {
  let instance = axios.create({
    baseURL: process.env.VUE_APP_AVANTI_API_URL,
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=UTF-8'
    }
  })

  // Intercept requests - and start progress bar
  instance.interceptors.request.use(
    config => {
      return config
    }
  )

  // Intercept responses - and stop progress bar
  instance.interceptors.response.use(
    response => {
      return response
    },
    error => {
      // Network error, timeout or cancelled request: there is no response to
      // inspect. Reject with the original error instead of throwing a
      // TypeError out of the interceptor.
      if (!error.response) {
        return Promise.reject(error)
      }

      const status = error.response.status

      // 401 = the JWT is missing, expired, or no longer resolves to an active
      // user. Match on the HTTP status: the API returns CakePHP's standard
      // error body ({ message: 'Authentication is required to continue',
      // code: 401 }) and does not send the old 'Expired token' / 418 shape.
      if (status === 401 && !isAuthEndpoint(error.config && error.config.url)) {
        // Make sure this only happens one time
        const currentModal = store.getters.getCurrentModal

        if (!(currentModal && currentModal.modalName === 'login-modal')) {
          store.dispatch('OPEN_MODAL', {
            modalName: 'login-modal',
            modalProps: null,
            modalType: null,
            modalOnCloseEvent: null
          })
        }
      }

      return Promise.reject(error)
    }
  )

  return instance
}



// WEBPACK FOOTER //
// ./src/services/Api.js